import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Form, Select, DatePicker, Radio, Button } from 'antd';
import moment from 'moment';
import http from '../../../Http';
import utils from '../../../utils';
import ReactECharts from 'echarts-for-react';
import calc from '../calc.js';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';

const pvOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(pvOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

const batOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(pvOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

const acOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(pvOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

const loadOption = {
    tooltip: {
        trigger: 'axis'
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: "Download",
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: () => {
                    console.log(pvOption);
                }
            }
        }
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            formatter: (value) => {
                return moment(value).format('HH:mm')
            }
        }
    },
    yAxis: {
        type: 'value',
    },
    color: '#0486be',
    series: [
        {
            name: '',
            type: 'line',
            symbol: 'none',
            lineStyle: { width: 2 },
            smooth: true,
            data: [],
            markLine: {
                symbol: 'none',
                data: [{ type: 'average', name: 'Avg' }],
                lineStyle: { color: 'blue', type: 'dashed' },
                label: { formatter: `Avg: {c}`, position: 'insideStartTop', color: '#629e0e', fontWeight: 'bold' }
            }
        }
    ]
}

function RuntimeParameterUhomeSinglePhase(props) {
    const { t } = useTranslation();
    const { Timezone, inverterSelectOptions, SN, protocol, handleSelectSN } = props
    const [invData, setInvData] = useState(null)  //逆变器数据
    const setTip = useContext(utils.tipContext)

    const [parameterDate, setParameterDate] = useState(moment().format('YYYY-MM-DD')) //时间

    const [activePV, setActivePV] = useState(0)
    const [activeBat, setActiveBat] = useState(0)
    const [activeAC, setActiveAC] = useState(0)
    const [activeLoad, setActiveLoad] = useState(0)
    const [PVTitle, setPVTitle] = useState(t('Vpv1(V)'))
    const [BatTitle, setBatTitle] = useState(t('SOC(%)'))
    const [ACTitle, setACTitle] = useState(t('Vacr(V)'))
    const [LoadTitle, setLoadTitle] = useState(t('Vac(V)'))

    const pvChart = useRef(null)
    const batChart = useRef(null)
    const acChart = useRef(null)
    const loadChart = useRef(null)

    
    useEffect(() => {
        console.log(pvOption)
        pvOption.series[0].markLine.data[0].name = t("Avg")
        pvOption.series[0].markLine.label.formatter = `${t('AVG')}: {c}`;
        batOption.series[0].markLine.data[0].name = t("Avg")
        batOption.series[0].markLine.label.formatter = `${t('AVG')}: {c}`;
        acOption.series[0].markLine.data[0].name = t("Avg")
        acOption.series[0].markLine.label.formatter = `${t('AVG')}: {c}`;
        loadOption.series[0].markLine.data[0].name = t("Avg")
        loadOption.series[0].markLine.label.formatter = `${t('AVG')}: {c}`;
    }, [t])
    
    //pvOption
    const exportToExcel_PV =  useCallback(() => {
        if (pvOption.series[0].data == null || pvOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activePV == 0 ? t('Vpv1') :
            activePV == 1 ? t('Vpv2') :
            activePV == 2 ? t('Vpv3') :
            activePV == 3 ? t('Vpv4') :
            activePV == 4 ? t('Ppv1') :
            activePV == 5 ? t('Ppv2') :
            activePV == 6 ? t('Ppv3') :
            activePV == 7 ? t('Ppv4') :
            "";

        let rs = 
        pvOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = pvOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_PV_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activePV,  t]);
    pvOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_PV;

    //batOption
    const exportToExcel_Bat =  useCallback(() => {
        if (batOption.series[0].data == null || batOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activeBat == 0 ? t('SOC(%)') :
            activeBat == 1 ? t('Vbat') :
            activeBat == 2 ? t('Ibat') :
            activeBat == 3 ? t('Pcharge') :
            activeBat == 4 ? t('Pdischarge') :
            "";

        let rs = 
        batOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = batOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_Battery_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activeBat,  t]);
    batOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_Bat;

    //acOption
    const exportToExcel_AC =  useCallback(() => {
        if (acOption.series[0].data == null || acOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activeAC == 0 ? t('Vacr') :
            activeAC == 1 ? t('Qac') :
            activeAC == 2 ? t('PToGrid') :
            activeAC == 3 ? t('PFromGrid') :"";

        let rs = 
        acOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = acOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_AC_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activeAC,  t]);
    acOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_AC;

    //loadOption
    const exportToExcel_Load =  useCallback(() => {
        if (loadOption.series[0].data == null || loadOption.series[0].data.length == 0) {
            return;
        }

        let fileName = activeLoad == 0 ? t('Vac') :
            activeLoad == 1 ? t('Pac') :
            activeLoad == 2 ? t('Qac') :
            "";

        let rs = 
        loadOption.series[0].data.map((v, i) => {
            let r = {};
            r[t("DataTime")] = loadOption.xAxis.data[i];
            r[t(fileName)] = v;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        
        XLSX.writeFile(wb, SN + '_Load_' + fileName + '_' + moment(parameterDate).format('YYYYMMDD') + ".xlsx");
    }, [ SN, activeLoad,  t]);
    loadOption.toolbox.feature.myDownloadXls.onclick = exportToExcel_Load;

    //获取日数据
    useEffect(() => {
        if (!SN) return;
        let active = true;
        (async () => {
            let resp = await http.post("integrated-inverter/uhome-singlephase/report/daily/report", {
                SerialNumber: SN,
                Date: parameterDate,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {  //请求日数据失败
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter record error") });
                return;
            } else {
                setInvData(resp.data)
            }
        })();

        return () => {
            active = false;
        };

    }, [SN, parameterDate]);

    //draw PV Chart
    useEffect(() => {
        if (!invData) {
            pvOption.xAxis.data = []
            pvOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                xData.push(moment(v['CreateTime']).format('YYYY-MM-DD HH:mm'))
                yData.push(activePV == 0 ? ((v['VPV1']??0)*0.1).toFixed(1) :
                    activePV == 1 ? ((v['VPV2']??0)*0.1).toFixed(1) :
                    activePV == 2 ? ((v['PPV1']??0)*0.001).toFixed(3) :
                    activePV == 3 ? ((v['PPV2']??0)*0.001).toFixed(3) :
                        null)
            })
            //x轴坐标
            pvOption.xAxis.data = xData;
            //数据
            pvOption.series[0] =
                activePV == 0 ? { ...pvOption.series[0], name: t('Vpv1'), data: yData } :
                    activePV == 1 ? { ...pvOption.series[0], name: t('Vpv2'), data: yData } :
                    activePV == 2 ? { ...pvOption.series[0], name: t('Ppv1'), data: yData } :
                    activePV == 3 ? { ...pvOption.series[0], name: t('Ppv2'), data: yData } :
                        null
        }
        const instance = pvChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(pvOption, true);
        }
    }, [invData, activePV, t])

    //draw Battery Chart
    useEffect(() => {
        if (!invData) {
            batOption.xAxis.data = []
            batOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                let power = 0
                // Convert IBattery to a signed 16-bit integer
                let IBattery = v['IBattery'];
                if (IBattery > 0x7fff) {
                    IBattery = IBattery - 0x10000;
                }
                IBattery = (IBattery * 0.1).toFixed(1)
                let PBattery = v['PBattery'];
                if (PBattery > 0x7fffffff) {
                    PBattery = PBattery - 0x100000000;
                }
                PBattery = (PBattery * 0.001).toFixed(3)
                xData.push(moment(v['CreateTime']).format('YYYY-MM-DD HH:mm'))
                yData.push(activeBat == 0 ? v['BatteryCapacity'] :
                    activeBat == 1 ? ((v['VBattery']??0)*0.01).toFixed(2) :
                    activeBat == 2 ? IBattery :
                    activeBat == 3 ? PBattery :
                        null)
            })
            //x轴坐标
            batOption.xAxis.data = xData;
            //数据
            batOption.series[0] =
                activeBat == 0 ? { ...batOption.series[0], name: t('SOC'), data: yData } :
                activeBat == 1 ? { ...batOption.series[0], name: t('VBat'), data: yData } :
                activeBat == 2 ? { ...batOption.series[0], name: t('IBat'), data: yData } :
                activeBat == 3 ? { ...batOption.series[0], name: t('Power'), data: yData } :
                    null
        }

        const instance = batChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(batOption, true);
        }
    }, [invData, activeBat, t])

    //draw AC Chart
    useEffect(() => {
        if (!invData) {
            acOption.xAxis.data = []
            acOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                let PAC1Grid = 0
                let QAC1Grid = 0
                // Convert PAC1Grid to a signed 16-bit integer
                PAC1Grid = v['PAC1Grid'];
                if (PAC1Grid > 0x7fffffff) {
                    PAC1Grid = PAC1Grid - 0x100000000;
                }
                PAC1Grid = (PAC1Grid * 0.001).toFixed(3);

                // Convert QAC1Grid to a signed 16-bit integer
                QAC1Grid = v['QAC1Grid'];
                if (QAC1Grid > 0x7fffffff) {
                    QAC1Grid = QAC1Grid - 0x100000000;
                }
                QAC1Grid = (QAC1Grid * 0.001).toFixed(3);
                
                xData.push(moment(v['CreateTime']).format('YYYY-MM-DD HH:mm'))
                yData.push(activeAC == 0 ? (v['VAC1Grid']*0.1).toFixed(1) :
                    activeAC == 1 ? PAC1Grid :
                    activeAC == 2 ? QAC1Grid :
                        null)
            })
            //x轴坐标
            acOption.xAxis.data = xData
            //数据
            acOption.series[0] =
                activeAC == 0 ? { ...acOption.series[0], name: t('Vacr'), data: yData } :
                activeAC == 1 ? { ...acOption.series[0], name: t('Pac'), data: yData } :
                activeAC == 2 ? { ...acOption.series[0], name: t('Qac'), data: yData } :
                    null
        }

        const instance = acChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(acOption, true);
        }
    }, [invData, activeAC])

    //draw Load Chart
    useEffect(() => {
        if (!invData) {
            loadOption.xAxis.data = []
            loadOption.series[0].data = []
        } else {
            const xData = []
            const yData = []
            //遍历结果，给坐标和数据赋值
            invData.forEach(v => {
                xData.push(moment(v['CreateTime']).format('YYYY-MM-DD HH:mm'))
                yData.push(activeLoad == 0 ? ((v['VAC1Load']??0)*0.1).toFixed(1) :
                activeLoad == 1 ? ((v['PAC1Load']??0)*0.001).toFixed(3) :
                activeLoad == 2 ? ((v['QAC1Load']??0)*0.001).toFixed(3) :
                    null)
            })
            //x轴坐标
            loadOption.xAxis.data = xData;
            //数据
            loadOption.series[0] =
                activeLoad == 0 ? { ...loadOption.series[0], name: t('Vac'), data: yData } :
                activeLoad == 1 ? { ...loadOption.series[0], name: t('Pac'), data: yData } :
                activeLoad == 2 ? { ...loadOption.series[0], name: t('Qac'), data: yData } :
                    null
        }

        const instance = loadChart.current.getEchartsInstance();
        if (instance) {
            instance.setOption(loadOption, true);
        }
    }, [invData, activeLoad, t])

    return (
        <div className="runtime-parameter">
            <div className="runtime-parameter-header">
                <span>{t('Select Inverter')}</span>
                <Select
                    showSearch
                    placeholder={t('Enter Inverter Name')}
                    defaultActiveFirstOption={false}
                    showArrow={true}
                    filterOption={true}
                    onSelect={(value, option) => handleSelectSN(value, option)}
                    value={SN}
                    style={{ width: '200px', marginRight: '20px' }}
                >{inverterSelectOptions}</Select>
                <DatePicker
                    defaultValue={moment()}
                    value={moment(parameterDate)}
                    onChange={(_, ds) => setParameterDate(ds)}
                    allowClear={false}
                />
            </div>
            <div className="runtime-parameter-main">
                <div className="side side-left">
                    <div className="title">{t('PV Side')}</div>
                    <div className="item">
                        <ul>
                            <li className={activePV == 0 ? 'active' : null} onClick={() => {
                                setActivePV(0)
                                setPVTitle(t('Vpv1(V)'))
                            }}>{t('Vpv1(V)')}</li>
                            <li className={activePV == 1 ? 'active' : null} onClick={() => {
                                setActivePV(1)
                                setPVTitle(t('Vpv2(V)'))
                            }}>{t('Vpv2(V)')}</li>
                            <li className={activePV == 2 ? 'active' : null} onClick={() => {
                                setActivePV(2)
                                setPVTitle(t('Ppv1(kW)'))
                            }}>{t('Ppv1(kW)')}</li>
                            <li className={activePV == 3 ? 'active' : null} onClick={() => {
                                setActivePV(3)
                                setPVTitle(t('Ppv2(kW)'))
                            }}>{t('Ppv2(kW)')}</li>

                        </ul>
                    </div>
                </div>
                <div className="box box-left">
                    <div className="title">
                        {PVTitle} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={pvChart} option={pvOption} style={{ height: 280 }} />
                    </div>
                </div>
                <div className="side side-right">
                    <div className="title">{t('Battery')}</div>
                    <div className="item">
                        <ul>
                            <li className={activeBat == 0 ? 'active' : null} onClick={() => {
                                setActiveBat(0)
                                setBatTitle(t('SOC(%)'))
                            }}>{t('SOC(%)')}</li>
                            <li className={activeBat == 1 ? 'active' : null} onClick={() => {
                                setActiveBat(1)
                                setBatTitle(t('vBat(V)'))
                            }}>{t('VBat(V)')}</li>
                            <li className={activeBat == 2 ? 'active' : null} onClick={() => {
                                setActiveBat(2)
                                setBatTitle(t('IBat(A)'))
                            }}>{t('IBat(A)')}</li>
                            <li className={activeBat == 3 ? 'active' : null} onClick={() => {
                                setActiveBat(3)
                                setBatTitle(t('Power(kW)'))
                            }}>{t('Power(kW)')}</li>
                        </ul>
                    </div>
                </div>
                <div className="box">
                    <div className="title">
                        {BatTitle} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={batChart} option={batOption} style={{ height: 280 }} />
                    </div>
                </div>
                <div style={{ clear: 'both' }}></div>
                <div className="side side-left">
                    <div className="title">{t('AC Side')}</div>
                    <div className="item">
                        <ul>
                            <li className={activeAC == 0 ? 'active' : null} onClick={() => {
                                setActiveAC(0)
                                setACTitle(t('Vac(V)'))
                            }}>{t('Vacr(V)')}</li>
                            <li className={activeAC == 1 ? 'active' : null} onClick={() => {
                                setActiveAC(1)
                                setACTitle(t('Pac(kW)'))
                            }}>{t('Pac(kW)')}</li>
                            <li className={activeAC == 2 ? 'active' : null} onClick={() => {
                                setActiveAC(2)
                                setACTitle(t('Qac(kW)'))
                            }}>{t('Qac(kW)')}</li>
                        </ul>
                    </div>
                </div>
                <div className="box box-left">
                    <div className="title">
                        {ACTitle} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={acChart} option={acOption} style={{ height: 280 }} />
                    </div>
                </div>
                <div className="side side-right">
                    <div className="title">{t('Load')}</div>
                    <div className="item">
                        <ul>
                            <li className={activeLoad == 0 ? 'active' : null} onClick={() => {
                                setActiveLoad(0)
                                setLoadTitle(t('Vac(V)'))
                            }}>{t('Vac(V)')}</li>
                            <li className={activeLoad == 1 ? 'active' : null} onClick={() => {
                                setActiveLoad(1)
                                setLoadTitle(t('Pac(kW)'))
                            }}>{t('Pac(kW)')}</li>
                            <li className={activeLoad == 2 ? 'active' : null} onClick={() => {
                                setActiveLoad(2)
                                setLoadTitle(t('Qac(kW)'))
                            }}>{t('Qac(kW)')}</li>
                        </ul>
                    </div>
                </div>
                <div className="box">
                    <div className="title">
                        {LoadTitle} - ({SN}, {parameterDate})
                    </div>
                    <div className="chart">
                        <ReactECharts ref={loadChart} option={loadOption} style={{ height: 280 }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RuntimeParameterUhomeSinglePhase;